<template>
    <IndexBase @auth="onAuth($event)" action="Promotion" controller="Appraisal"></IndexBase>

    <OverlayPanel ref="op" :showCloseIcon="true" :dismissable="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '450px' }">
        <InputText v-model="overlayText" @input="onEditRemarks" style="width:100%" />
    </OverlayPanel>

    <Dialog :header="$t('information') + ' (' + this.nikPromot + ' - ' + this.namePromot + ')'"
        v-model:visible="showInfoModal" :closeOnEscape="false" :closable="false" :modal="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '40vw' }">
        <Fieldset :legend="$t('remark')" :toggleable="true" :collapsed="false">
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="field grid">
                            <label for="S_Remark" class="col-3">Superior</label>
                            <div class="col-7 md-7">
                                <Textarea name="S_Remark" v-model="this.header.S_Remark" type="text"
                                    :placeholder="$t('remark')" :disabled="true" :autoResize="true" rows="3"
                                    cols="30" />
                            </div>
                            <div class="col-2">
                                <Tag v-if="this.header.S_Promotion" class="mr-2" :severity="'success'"
                                    :value="this.$Status_Promotion.APPROVED">
                                </Tag>
                                <Tag v-else-if="this.header.S_Remark" class="mr-2" :severity="'danger'"
                                    :value="this.$Status_Promotion.REJECTED">
                                </Tag>
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="H_Remark" class="col-3">Head Superior</label>
                            <div class="col-7 md-7">
                                <Textarea name="H_Remark" v-model="this.header.H_Remark" type="text"
                                    :placeholder="$t('remark')" :disabled="true" :autoResize="true" rows="3"
                                    cols="30" />
                            </div>
                            <div class="col-2">
                                <Tag v-if="this.header.H_Promotion" class="mr-2" :severity="'success'"
                                    :value="this.$Status_Promotion.APPROVED">
                                </Tag>
                                <Tag v-else-if="this.header.H_Remark" class="mr-2" :severity="'danger'"
                                    :value="this.$Status_Promotion.REJECTED">
                                </Tag>
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="K_Remark" class="col-3">HRR/PGA Head/OU Head</label>
                            <div class="col-7 md-7">
                                <Textarea name="K_Remark" v-model="this.header.K_Remark" type="text"
                                    :placeholder="$t('remark')" :disabled="true" :autoResize="true" rows="3"
                                    cols="30" />
                            </div>
                            <div class="col-2">
                                <Tag v-if="this.header.K_Promotion && this.header.K_Activity == 'Approve'" class="mr-2"
                                    :severity="'success'" :value="this.$Status_Promotion.APPROVED">
                                </Tag>
                                <Tag v-else-if="this.header.K_Activity == 'Reject'" class="mr-2" :severity="'danger'"
                                    :value="this.$Status_Promotion.REJECTED">
                                </Tag>
                                <Tag v-else-if="this.header.K_Activity == 'Cancel'" class="mr-2" :severity="'danger'"
                                    :value="this.$Status_Promotion.CANCELLED">
                                </Tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fieldset>
        <br />
        <Fieldset :legend="$t('promotion')" :toggleable="true" :collapsed="false"
            v-if="this.header.Status_Promotion == this.$Status_Promotion.APPROVED || this.header.Status_Promotion == this.$Status_Promotion.SYNC">
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="field grid">
                            <label for="Effective_Date" class="col-3">{{ $t('effective_date') }}</label>
                            <div class="col-9 md-9">
                                <DatePicker name="Effective_Date" v-model="this.header.Effective_Date"
                                    :showOnFocus="true" :placeholder="$t('effective_date')" dateFormat="dd/mm/yyyy"
                                    inputMask="99/99/9999" momentFormat="DD/MM/YYYY" :disabled="true" />
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="Reason" class="col-3">{{ $t('reason_promot') }}</label>
                            <div class="col-9 md-9">
                                <CustomSelect class="p-inputtext-sm" v-model="this.header.Reason" :filter="true"
                                    :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: 'PROMOTION' }"
                                    :disabled="true" />
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="Position" class="col-3">{{ $t('new_position') }}</label>
                            <div class="col-9 md-9">
                                <InputText name="Position" v-model="this.header.Position" type="text"
                                    :placeholder="$t('new_position')" :disabled="true" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fieldset>
        <template #footer>
            <div>
                <Button label="Close" @click="dismissInfo" />
            </div>
        </template>
    </Dialog>

    <Dialog
        :header="!this.syncAll ? $t('promot_confirmation') + ' (' + this.nikPromot + ' - ' + this.namePromot + ')' : $t('sync_confirmation')"
        v-model:visible="showPromotConfirmationModal" :closeOnEscape="false" :closable="false" :modal="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '35vw' }">
        <div v-if="!processed" class="p-inputtext-sm p-fluid">
            <div class="grid">
                <div class="col-12">
                    <div class="field grid" v-if="this.action != 'Sync to Fiori'">
                        <label for="K_Remark" class="col-4">Remarks<span style="color: red;">*</span></label>
                        <div class="col-8 md-8">
                            <Textarea name="K_Remark" v-model="this.header.K_Remark" type="text"
                                :placeholder="$t('remark_1000')"
                                :class="{ 'p-invalid': submitted && !this.header.K_Remark }" v-if="header"
                                :autoResize="true" rows="3" cols="30" maxlength="1000" />
                            <Skeleton v-else-if="!header" />
                            <small v-if="header && !this.header.K_Remark && submitted" class="p-error">
                                {{ $t('is_required').replace('Value', $t('remark')) }}
                            </small>
                            <br />
                            <small v-if="header && this.action == 'Cancel'" class="p-warning">{{
        this.$t('note.cancel_promot') }}
                            </small>
                        </div>
                    </div>
                    <div v-else class="field grid">
                        <div v-if="!this.syncAll">
                            <i class="pi pi-exclamation-triangle" style="font-size: 1.5rem"></i>&nbsp;&nbsp;
                            Are you sure to sync to Fiori ( {{ this.nikPromot + ' - ' + this.namePromot + ' - ' +
        this.positionPromot }} ) promotion request ?
                        </div>
                        <div v-else>
                            {{ this.dataModelAll.length <= 0 ? this.$t('message.sync_no_data') :
        this.$t('message.sync_promot_confirmation') }} <table>
                                <tr v-for="(doc, index) in this.dataModelAll" v-bind:key="doc.NIK">
                                    <td style="width: 10%;">{{ (index + 1) }}.</td>
                                    <td style="width: 30%;">{{ doc.NIK }}</td>
                                    <td style="width: 30%;">{{ doc.Employee_Name }}</td>
                                    <td style="width: 30%;">{{ doc.Position }}</td>
                                </tr>
                                </table>
                        </div>
                    </div>
                    <div class="field grid" v-if="this.action == 'Approve' || this.action == 'Edit'">
                        <label for="Effective_Date" class="col-4">{{ $t('effective_date') }}<span
                                style="color: red;">*</span></label>
                        <div class="col-8 md-8">
                            <DatePicker name="Effective_Date" v-model="this.header.Effective_Date" :showOnFocus="true"
                                :placeholder="$t('effective_date')" v-if="header"
                                :class="{ 'p-invalid': submitted && !this.header.Effective_Date }"
                                dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true" />
                            <Skeleton v-else-if="!header" />
                            <small class="p-error" v-if="header && !this.header.Effective_Date && submitted">
                                {{ $t('is_required').replace('Value', $t('remark')) }}
                            </small>
                        </div>
                    </div>
                    <div class="field grid" v-if="this.action == 'Approve' || this.action == 'Edit'">
                        <label for=" Reason" class="col-4">{{ $t('reason_promot') }}<span
                                style="color: red;">*</span></label>
                        <div class="col-8 md-8">
                            <CustomSelect class="p-inputtext-sm" v-model="this.header.Reason" :filter="true"
                                :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: 'PROMOTION' }"
                                :class="{ 'p-invalid': submitted && !this.header.Reason }" v-if="header" />
                            <Skeleton v-else-if="!header" />
                            <small class="p-error" v-if="header && !this.header.Reason && submitted">
                                {{ $t('is_required').replace('Value', $t('reason_promot')) }}
                            </small>
                        </div>
                    </div>
                    <div class="field grid" v-if="this.action == 'Approve' || this.action == 'Edit'">
                        <label for=" Position" class="col-4">{{ $t('new_position') }}<span
                                style="color: red;">*</span></label>
                        <div class="col-8 md-8">
                            <InputText name="Position" v-model="this.header.Position" type="text"
                                :placeholder="$t('new_position')"
                                :class="{ 'p-invalid': submitted && !this.header.Position }" v-if="header" />
                            <Skeleton v-else-if="!header" />
                            <small class="p-error" v-if="header && !this.header.Position && submitted">
                                {{ $t('is_required').replace('Value', $t('new_position')) }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <center v-if="!this.syncAll">
                <div v-if="this.action == 'Sync to Fiori'">
                    <div v-if="resultData.message == 'SUCCESS'">
                        <Button icon="pi pi-check" class="p-button-rounded p-button-outlined mr-2 mb-2"
                            label="SUCCESS" /><br>
                        <Button :label="resultData.message" class="p-button-success p-button-text mr-2 mb-2" />
                    </div>
                    <div v-else>
                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2"
                            label="FAILED" /><br>
                        <Button :label="resultData.message" class="p-button-danger p-button-text mr-2 mb-2" />
                    </div>
                </div>
                <div v-else-if="resultData.success">
                    <Button icon="pi pi-check" class="p-button-rounded p-button-outlined mr-2 mb-2" /><br>
                    <Button :label="resultData.message" class="p-button-success p-button-text mr-2 mb-2" />
                </div>
                <div v-else>
                    <Button icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" /><br>
                    <Button :label="resultData.message" class="p-button-danger p-button-text mr-2 mb-2" />
                </div>
            </center>
            <table v-if="this.syncAll">
                <tr v-for="(doc, index) in [...new Set(resultDataAll)]" v-bind:key="doc.NIK" v-if="this.syncAll">
                    <td style="width: 10%;">{{ (index + 1) }}.</td>
                    <td style="width: 15%;">{{ doc.NIK }}</td>
                    <td style="width: 25%;">{{ doc.Name }}</td>
                    <td style="width: 40%;">
                        <Tag class="mr-2" severity="danger" :value="doc.Result"></Tag>
                    </td>
                </tr>
            </table>
            <div v-if="this.syncAll">
                <h3 style="color:green;margin:0px;">
                    {{ resultDataAll.filter(a => a.Result.indexOf('SUCCESS') > -1).length }}
                    {{ this.$t('sap_result_success') }}
                </h3>
                <h3 style="color:red;margin:0px;">
                    {{ resultDataAll.filter(a => a.Result.indexOf('SUCCESS') < 0).length }} {{
        this.$t('sap_result_failed') }} </h3>
            </div>
        </div>

        <template #footer>
            <div v-if="processed">
                <Button label="Close" @click="dismissConfirmationLoad()" />
            </div>
            <div v-else>
                <div v-if="processing">
                    <ProgressSpinner style="width:50px;height:50px" />
                    <ProgressBar :value="this.precentageProgress" v-if="this.syncAll">
                        {{ this.beginLoop }}/{{ this.dataModelAll.length }}
                    </ProgressBar>
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button :label="this.syncAll ? 'No' : 'Back'" @click="dismissConfirmation()" />
                        <Button label="Approve" autofocus @click="submitApprove($event)"
                            class="pi-button p-button-success" v-if="this.action == 'Approve'" />
                        <Button label="Reject" autofocus @click="submitReject($event)" class="pi-button p-button-danger"
                            v-if="this.action == 'Reject'" />
                        <Button label="Cancel" autofocus @click="submitCancel($event)" class="pi-button p-button-danger"
                            v-if="this.action == 'Cancel'" />
                        <Button label="Submit" autofocus @click="submitApprove($event)"
                            class="pi-button p-button-success" v-if="this.action == 'Edit'" />
                        <Button label="Submit" autofocus @click="submit()" class="pi-button p-button-warning"
                            v-if="this.action == 'Sync to Fiori' && !this.syncAll" />
                        <Button label="Yes" autofocus @click="syncAllFiori()" class="pi-button p-button-success"
                            v-if="this.action == 'Sync to Fiori' && this.syncAll" />
                        <ConfirmPopup></ConfirmPopup>
                    </div>
                    <div v-else>
                        <Button label="Close" autofocus icon="pi pi-times" class="p-button-text"
                            @click="dismissConfirmationLoad()" />
                    </div>
                </div>
            </div>
        </template>
    </Dialog>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('promotion_request') }}
                    </div>
                </template>
                <template #right>
                    <div class="p-card-title" style="margin-top:10px;">
                        <Button label="Sync All to Fiori" icon="pi pi-sync" class="p-button-warning p-button-sm"
                            @click="confirmAllSync()" style="margin-left:5px;"
                            v-if="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT || this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin)
        && this.dataModel && this.dataModel.filter(a => a.Status_Promotion == this.$Status_Promotion.APPROVED && a.Source == 'HCM' && a.Period_Year == this.$store.getters.getPeriorYear).length > 0" />
                    </div>
                </template>
            </Toolbar>
            <Toolbar>
                <template #left>
                    <div class="alert alert-info"><b>{{ this.$t('note.promote') }}</b>
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort v-model:expandedRows="expandedRows" stateStorage="local" :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading" :paginator="true" :rows="10" :lazy="true"
                v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" @rowExpand="onRowExpand"
                @state-restore="onStateRestore($event)" @state-save="onStateSave($event)" @page="onPage($event)"
                @sort="onSort($event)" @filter="onFilter($event)" @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick" v-model:filters="filters" :totalRecords="totalRecords"
                v-model:selection="selectedRow" dataKey="Id" :metaKeySelection="false">
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter"
                            :badge="filterBadge" badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel"
                        v-if="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT || this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin)">
                        <Button icon="pi pi-check" v-tooltip.bottom="'Approve'"
                            v-if="dataModel.data.Status_Promotion == this.$Status_Promotion.REQUESTED && dataModel.data.Period_Year == this.$store.getters.getPeriorYear"
                            class="p-button-rounded p-button-success p-button-outlined mr-2 p-button-sm"
                            @click="confirmApprove(dataModel.data)" />
                        <Button icon="pi pi-times" v-tooltip.bottom="'Reject'"
                            v-if="dataModel.data.Status_Promotion == this.$Status_Promotion.REQUESTED && dataModel.data.Period_Year == this.$store.getters.getPeriorYear"
                            class="p-button-rounded p-button-danger p-button-outlined mr-2 p-button-sm"
                            @click="confirmReject(dataModel.data)" />
                        <Button icon="pi pi-sync" v-tooltip.bottom="'Sync to Fiori'"
                            v-if="dataModel.data.Status_Promotion == this.$Status_Promotion.APPROVED && dataModel.data.Period_Year == this.$store.getters.getPeriorYear"
                            class="p-button-rounded p-button-warning p-button-outlined mr-2 p-button-sm"
                            @click="confirmSync(dataModel.data)" />
                        <Button icon="pi pi-ban" v-tooltip.bottom="'Cancel Promotion'"
                            v-if="dataModel.data.Status_Promotion == this.$Status_Promotion.APPROVED && dataModel.data.Period_Year == this.$store.getters.getPeriorYear"
                            class="p-button-rounded p-button-danger p-button-outlined mr-2 p-button-sm"
                            @click="confirmCancel(dataModel.data)" />
                        <Button icon="pi pi-pencil" v-tooltip.bottom="'Edit'"
                            v-if="dataModel.data.Status_Promotion == this.$Status_Promotion.APPROVED && dataModel.data.Period_Year == this.$store.getters.getPeriorYear"
                            class="p-button-rounded p-button-info p-button-outlined mr-2 p-button-sm"
                            @click="confirmEdit(dataModel.data)" />
                        <Button icon="pi pi-list" v-tooltip.bottom="'Historical Appraisal'"
                            class="p-button-rounded p-button-secondary p-button-outlined mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_HISTORY, dataModel.data.Id)" />
                        <Button icon="pi pi-info" v-tooltip.bottom="'Remarks'"
                            class="p-button-rounded p-button-help p-button-outlined mr-2 p-button-sm"
                            @click="showInfo(dataModel.data)" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Column>
                <Column field="Period_Year" :header="$t('period')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('period')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Status_Promotion" :header="$t('status')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('status')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        <Tag :value="data.Status_Promotion" :severity="getClassColor(data.Status_Promotion)" />
                    </template>
                </Column>
                <Column field="NIK" :header="$t('nik')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('nik')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Employee_Name" :header="$t('name')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('name')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Grade" :header="$t('grade')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('grade')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Unit_Name" :header="$t('unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('unit')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Score" :header="$t('score')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('score')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ data.Score }} %
                    </template>
                </Column>
                <Column field="Rate" :header="$t('rate')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="LengthWork" :header="$t('lengthWork')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('lengthWork')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="LengthGrade" :header="$t('lengthGrade')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('lengthGrade')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="SP" header="SP" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" placeholder="SP" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Education" :header="$t('education')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('education')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Requested_Date" :header="$t('requested_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('requested_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Requested_Date) }}
                    </template>
                </Column>
                <Column field="Requested_By" :header="$t('requested_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('requested_by')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Requester" :header="$t('requester')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('requester')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="S_Edit" :header="$t('superior1')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('superior1')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="H_Edit" :header="$t('superior2')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('superior2')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="OH_Edit" :header="$t('committee')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" placeholder="OU Head" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="K_Edit" :header="$t('hrr')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('hrr')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Effective_Date" :header="$t('effective_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('effective_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDate(data.Effective_Date) }}
                    </template>
                </Column>
                <Column field="Reason_Name" :header="$t('reason')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('reason')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Position" :header="$t('new_position')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('new_position')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Appraisal",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'appraisal-promot' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/Appraisal/Editor",
            dataUrl: "appraisal/listPromotion",
            promotUrl: "appraisal/promot/",
            syncAllUrl: "appraisal/sync_all_promotion/",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            overlayText: "",
            showPromotConfirmationModal: false,
            showInfoModal: false,
            confirmationStatus: "",
            processed: false,
            namePromot: null,
            nikPromot: null,
            positionPromot: null,
            processing: false,
            action: "",
            header: null,
            submitted: false,
            syncAll: false,
            resultDataAll: [],
            pageSize: 10,
            dataModelAll: null,
            limit: 0,
            beginLoop: 0,
            loopCount: 0,
            indexCount: 0,
            precentageProgress: 0,
            syncUrl: "appraisal/sync_promot",
        }
    },
    methods: {
        onEditRemarks() {
            this.overlayData.Remarks = this.overlayText;
        },
        toggleRemarksPopup(event, data) {
            this.overlayData = data;
            this.overlayText = data.Remarks;
            this.$refs.op.toggle(event);
        },
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        dismissInfo() {
            this.showInfoModal = false;
            this.syncAll = false;
        },
        showInfo(data) {
            this.showInfoModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.header = data;
        },
        dismissConfirmation() {
            this.processed = false;
            this.showPromotConfirmationModal = false;
            this.submitted = false;
            this.syncAll = false;
        },
        dismissConfirmationLoad() {
            this.processed = false;
            this.showPromotConfirmationModal = false;
            this.submitted = false;
            this.loadLazyData();
            this.syncAll = false;
        },
        confirmApprove(data) {
            this.showPromotConfirmationModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.action = "Approve";
            this.header = data;
            this.header.mode = this.action;
            this.header.K_Remark = data.K_Remark;
            this.header.Effective_Date = new Date((new Date().getFullYear() + 1) + "-04-01");
            this.header.Reason = "Z1_13";
            this.header.Position = "";
        },
        confirmReject(data) {
            this.showPromotConfirmationModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.action = 'Reject';
            this.header = data;
            this.header.mode = this.action;
        },
        confirmEdit(data) {
            this.showPromotConfirmationModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.action = "Edit";
            this.header = data;
            this.header.mode = this.action;
            this.header.K_Remark = data.K_Remark;
            this.header.Effective_Date = data.Effective_Date;
            this.header.Reason = data.Reason;
            this.header.Position = data.Position;
        },
        confirmCancel(data) {
            this.showPromotConfirmationModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.action = "Cancel";
            this.header = data;
            this.header.mode = this.action;
            this.header.K_Remark = "";
        },
        confirmSync(data) {
            this.showPromotConfirmationModal = true;
            this.namePromot = data.Employee_Name;
            this.nikPromot = data.NIK;
            this.positionPromot = data.Position;
            this.action = "Sync to Fiori";
            this.header = data;
            this.header.mode = this.action;
        },
        confirmAllSync() {
            var self = this;

            this.$axios.put(this.$API_URL + this.syncAllUrl)
                .then((response) => {
                    if (response.data.success) {
                        self.dataModelAll = response.data.data;
                        self.beginLoop = 0;
                        self.indexCount = 0;
                        self.loopCount = Math.ceil(this.dataModelAll.length / 100);
                        self.limit = this.dataModelAll.length > 100 ? 100 : this.dataModelAll.length;
                    }
                    else
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                })
                .finally(() => {
                    this.syncAll = true;
                    this.showPromotConfirmationModal = true;
                    this.action = "Sync to Fiori";
                });
        },
        submitApprove(event) {
            this.submitted = true;
            if (!this.header.K_Remark || !this.header.Reason || !this.header.Position || !this.header.Effective_Date) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure to ' + this.action + ' ' + this.nikPromot + ' - ' + this.namePromot + ' promotion request ?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.submit();
                    },
                    reject: () => {

                    }
                });
            }
        },
        submitReject(event) {
            this.submitted = true;
            if (!this.header.K_Remark) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure to reject ' + this.nikPromot + ' - ' + this.namePromot + ' promotion request ?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.submit();
                    },
                    reject: () => {

                    }
                });
            }
        },
        submitCancel(event) {
            this.submitted = true;
            if (!this.header.K_Remark) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure to cancel ' + this.nikPromot + ' - ' + this.namePromot + ' promotion request ?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.submit();
                    },
                    reject: () => {

                    }
                });
            }
        },
        submit() {
            var self = this;
            self.processing = true;

            this.$axios.post(this.$API_URL + this.promotUrl, this.header)
                .then((response) => {
                    self.processed = true;
                    self.resultData = response.data;

                    if (this.action == 'Sync to Fiori') {
                        if (response.data.success)
                            self.$toast.add({ severity: 'success', summary: 'Data Sent', detail: "Promotion data successfully sent to SAP Fiori", life: 5000 });
                        else
                            self.$toast.add({ severity: 'error', summary: "Data Failed to Send", detail: response.data.message, life: 5000 });
                    }
                })
                .catch(function (error) {
                    self.processed = false;
                    self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        syncAllFiori() {
            var self = this;
            self.submitted = true;

            if (self.loopCount != 0 && self.limit != 0) {
                let listModel = [];

                for (let j = self.beginLoop; j < self.limit; j++) {
                    var empData = self.dataModelAll[j];
                    var newDate = new Date(empData.Effective_Date);
                    var effectivedate = ("0" + newDate.getDate()).slice(-2) + "." + ('0' + (newDate.getMonth() + 1)).slice(-2) + '.' + newDate.getFullYear();

                    var data =
                    {
                        Id: empData.Id,
                        NIK: empData.NIK,
                        Effective_date: effectivedate,
                        Grade: empData.Grade,
                        Action: empData.Reason.substring(0, 2),
                        Reason_for_Action: empData.Reason.substring(5, 3),
                        Comment_Position: empData.K_Remark,
                        New_Position: empData.Position,
                        Result: '',
                        Name: empData.Employee_Name
                    };

                    listModel.push(data);
                }

                self.processing = true;

                this.$axios.put(this.$API_URL + this.syncUrl, listModel)
                    .then((response) => {
                        if (response.data.success) {
                            if (self.beginLoop == 0)
                                self.resultDataAll = response.data.data;
                            else
                                self.resultDataAll = [].concat(self.resultDataAll, response.data.data);

                            self.precentageProgress = self.limit / self.dataModelAll.length * 100;
                        }
                        else {
                            self.loopCount = 0;
                            self.limit = 0;
                            self.$toast.add({ severity: 'error', summary: "Data Failed to Send", detail: response.data.message, life: 5000 });
                        }
                    })
                    .catch(function (error) {
                        self.loopCount = 0;
                        self.limit = 0;
                        self.processed = false;
                        self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
                    })
                    .finally(() => {
                        self.beginLoop = self.limit;
                        self.indexCount++;

                        if (self.indexCount == self.loopCount) {
                            self.loopCount = 0;
                            self.limit = 0;
                            self.processed = true;
                            self.processing = false;
                            self.$toast.add({ severity: 'success', summary: 'Data Sent', detail: "Appraisal data successfully sent to SAP HCM", life: 5000 });
                        }
                        else {
                            self.limit += self.limit;

                            if (self.limit > self.dataModelAll.length)
                                self.limit = self.dataModelAll.length;

                            self.confirmSync();
                        }
                    });
            }
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize: this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters(defaultPeriod) {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (defaultPeriod && exportable[i].props.field == 'Period_Year') {
                    filterValue = defaultPeriod;
                }
                else if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
            this.pageSize = event.rows;
        },
        onStateSave(event) {
            event.selectedCategoryIndex = this.selectedCategoryIndex;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        editor(mode, id) {
            this.$router.push({ path: this.editorPath, query: { mode: mode, id: id, fromMenu: 'AppraisalPromotionIndex' } });
        },
        getClassColor(status) {
            if (status == this.$Status_Promotion.REQUESTED)
                return 'info';
            else if (status == this.$Status_Promotion.SYNC)
                return 'warning';
            else if (status == this.$Status_Promotion.APPROVED)
                return 'success';
            else if (status == this.$Status_Promotion.REJECTED || status == this.$Status_Promotion.CANCELLED)
                return 'danger';
            else return '';
        }
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters(this.$store.getters.getPeriorYear);
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        },
    },
}
</script>

<style scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}

.alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
}

.alert {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
}

.p-fieldset-content {
    padding: 0px !important;
}
</style>